export default "__VITE_PUBLIC_ASSET__70aba652__"